// icons
import BidIcon from '../assets/sidebar/bid.svg';
import DashboardIcon from '../assets/sidebar/Dashboard.svg';
import systemIcon from '../assets/sidebar/systemTool.svg';
import AdminIcon from '../assets/Admin.svg';
import triggerLogsIcon from '../assets/triggerLogsIcon.svg';
import globalConfigIcon from '../assets/globalConfigIcon.svg';
import EconomicsIcon from '../assets/sidebar/economic.svg';
import DocumentsIcon from '../assets/sidebar/documents.svg';
import BusinessWebsiteIcon from '../assets/sidebar/business website.svg';
import OverviewIcon from '../assets/sidebar/Overview.svg';
import MonitoringIcon from '../assets/Monitoring.svg';
import DemandResponseIcon from '../assets/DemandResponse.svg';
import Pricing from '../assets/pricing.svg';

// admin
import Home from '../containers/Home/Home';
import FCR from '../containers/Bidding/FCR';
import FFR from '../containers/Bidding/FFR';
import FCRD from '../containers/Bidding/FCR-D';
import FCRDMinus from '../containers/Bidding/FCR-DMinus';
import DCPlanner from '../containers/Bidding/DCPlanner';
import AFRR from '../containers/Bidding/AFRR';
import MFRR from '../containers/Bidding/MFRR';
import SystemTools from '../containers/SystemTools';
import Edge from '../containers/Edge';
import Economics from '../containers/Economics/Economics';
import AdminDocuments from '../containers/Documents';
import BiddingIndex from '../containers/Bidding';
import MasterBiddingMain from '../containers/MasterBidding';
import MFRRMonitoringMainAdmin from '../containers/FRR/MFRR';

// root
import Admin from '../containers/Root/Admin/Admin';
import SystemToolsForRoot from '../containers/Root/SystemTools';
import GlobalConfig from '../containers/Root/GlobalConfig';
import RootEconomics from '../containers/Root/Economics/Economics';
import SystemLogs from '../containers/Root/SystemLogs/SystemLogs';
import Approval from '../containers/Bidding/ApprovalOverview';
import Content from '../containers/Root/Content';
import Monitoring from '../containers/Root/Monitoring/Monitoring';

// enabler
import EnablerEconomics from '../containers/Enabler/Economics/Economics';
import Bidding from '../containers/Root/Bidding';
import MFRRMonitoringMain from '../containers/Root/FRR/MFRR/index';
import AfrrDashboard from '../containers/Root/FRR/AFRR';
import EIC from '../containers/FRR/AFRR';

export const PROTECTED_ROUTES = [
    {
        name: 'Customer',
        id: 'customer',
        url: '/',
        component: Home,
        icon: DashboardIcon,
    },
    {
        name: 'Bidding',
        id: 'bidding',
        url: '/bidding',
        icon: BidIcon,
        childRoutes: [
            {
                name: 'Appr. Overview',
                id: 'approvalOverview',
                url: '/approval-overview',
                component: Approval,
                icon: OverviewIcon,
            },
            {
                name: 'Master Bidding',
                id: 'masterBidding',
                url: '/master-bidding',
                icon: BidIcon,
                component: MasterBiddingMain,
            },
            {
                name: 'FCR',
                id: 'fcr',
                url: '/fcr',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'FFR',
                id: 'ffr',
                url: '/ffr',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'FCR-D-INC',
                id: 'fcr-d-inc',
                url: '/fcr-d-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'FCR-D-DEC',
                id: 'fcr-d-dec',
                url: '/fcr-d-minus',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'FCR-D-SE3-INC',
                id: 'fcr-d-se3-inc',
                url: '/fcr-d-se3-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'dcPlanner',
                id: 'dcPlanner',
                url: '/dc-planner',
                component: DCPlanner,
                icon: BidIcon,
            },
            {
                name: 'mFRR',
                id: 'mFRR',
                url: '/mfrr',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'aFRR-DK1-INC',
                id: 'afrr-dk1-inc',
                url: '/afrr-dk1-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'aFRR-DK1-DEC',
                id: 'afrr-dk1-dec',
                url: '/afrr-dk1-dec',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'aFRR-DK2-INC',
                id: 'afrr-dk2-inc',
                url: '/afrr-dk2-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'aFRR-DK2-DEC',
                id: 'afrr-dk2-dec',
                url: '/afrr-dk2-dec',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'mFRR-DK1-INC',
                id: 'mfrr-dk1-inc',
                url: '/mfrr-dk1-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'mFRR-DK1-DEC',
                id: 'mfrr-dk1-dec',
                url: '/mfrr-dk1-dec',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'mFRR-DK2-INC',
                id: 'mfrr-dk2-inc',
                url: '/mfrr-dk2-inc',
                component: BiddingIndex,
                icon: BidIcon,
            },
            {
                name: 'mFRR-DK2-DEC',
                id: 'mfrr-dk2-dec',
                url: '/mfrr-dk2-dec',
                component: BiddingIndex,
                icon: BidIcon,
            },
            // {
            //     name: 'FCR-D-DK2-INC',
            //     id: 'fcr-d-dk2-inc',
            //     url: '/fcr-d-dk2-inc',
            //     component: BiddingIndex,
            //     icon: BidIcon,
            // },
            // {
            //     name: 'FCR-D-DK2-DEC',
            //     id: 'fcr-d-dk2-dec',
            //     url: '/fcr-d-dk2-dec',
            //     component: BiddingIndex,
            //     icon: BidIcon,
            // },
            {
                name: 'FCR-N-DK2',
                id: 'fcr-n-dk2',
                url: '/fcr-n-dk2',
                component: BiddingIndex,
                icon: BidIcon,
            },
        ],
    },
    {
        name: 'System Tools',
        id: 'systemtool',
        url: '/systemtool',
        component: SystemTools,
        icon: systemIcon,
    },
    {
        name: 'eConomics',
        id: 'eConomics',
        url: '/eConomics',
        component: Economics,
        icon: EconomicsIcon,
    },
    {
        name: 'Documents',
        id: 'documents',
        url: '/documents',
        component: AdminDocuments,
        icon: DocumentsIcon,
    },
    {
        name: 'FRR',
        id: 'FRR',
        url: '/frr',
        icon: DemandResponseIcon,
        childRoutes: [
            {
                name: 'mFRR',
                id: 'mFRR',
                url: '/mfrr',
                component: MFRRMonitoringMainAdmin,
                icon: Pricing,
            },
            {
                name: 'aFRR',
                id: 'aFRR',
                url: '/afrr',
                component: EIC,
                icon: Pricing,
            },
        ],
    },
];

export const PROTECTED_ROUTES_ROOT = [
    {
        name: 'Accounts',
        id: 'admin',
        url: '/',
        component: Admin,
        icon: AdminIcon,
    },
    {
        name: 'Monitoring',
        id: 'monitoring',
        url: '/monitoring',
        component: Monitoring,
        icon: MonitoringIcon,
    },
    {
        name: 'System Tools',
        id: 'systemtool',
        url: '/systemtool',
        component: SystemToolsForRoot,
        icon: systemIcon,
    },
    {
        name: 'Bidding',
        id: 'bidding',
        url: '/bidding',
        icon: BidIcon,
        component: Bidding,
    },
    {
        name: 'System Logs',
        id: 'systemLogs',
        url: '/systemLogs',
        component: SystemLogs,
        icon: triggerLogsIcon,
    },
    {
        name: 'Global Config',
        id: 'globalConfig',
        url: '/globalConfig',
        component: GlobalConfig,
        icon: globalConfigIcon,
    },
    {
        name: 'eConomics',
        id: 'eConomics',
        url: '/eConomics',
        component: RootEconomics,
        icon: EconomicsIcon,
    },
    {
        name: 'Content',
        id: 'content',
        url: '/content',
        component: Content,
        icon: BusinessWebsiteIcon,
    },
    {
        name: 'FRR',
        id: 'FRR',
        url: '/frr',
        icon: DemandResponseIcon,
        childRoutes: [
            {
                name: 'mFRR',
                id: 'mFRR',
                url: '/mfrr',
                component: MFRRMonitoringMain,
                icon: Pricing,
            },
            {
                name: 'aFRR',
                id: 'aFRR',
                url: '/afrr',
                component: AfrrDashboard,
                icon: Pricing,
            },
        ],
    },
];

export const PROTECTED_ROUTES_ENABLER = [
    {
        name: 'eConomics',
        id: 'eConomics',
        url: '/',
        component: EnablerEconomics,
        icon: EconomicsIcon,
    },
];
